export default "__VITE_ASSET__66cf4a0f__"